export const SINGLE = 'Soltero';
export const MARRIED = 'Casado';
export const FREE_UNION = 'Unión libre';
